export default __webpack_public_path__ + "static/media/Quicksand-Medium.4fca22c4.ttf";